import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getEnvironment } from 'src/environments/dinamicEnv';

const environment = getEnvironment();

@Injectable()
export class BaseUrlService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let newReq = req;
    if (!req.url.includes('://') && !req.url.substr(0, 7).includes('assets')) {
      let { url } = req;
      if (url) {
        if (url[0] === '/') {
          url = url.substring(1);
        }
      }
      newReq = newReq.clone({ url: `${environment.baseUrl}${url}` });
    }
    return next.handle(newReq);
  }
}
